export function renderAIMessage(message) {
  const lines = message?.content?.split("\n")
  const elements = []
  let list = null

  const msgId = message?.id

  lines.forEach((line) => {
    const bulletMatch = line.match(/^[•-]\s?(.*)/)
    if (bulletMatch) {
      if (!list) list = []
      list.push(<li key={`${msgId}-li`}>{bulletMatch[1]}</li>)
    } else {
      if (list) {
        elements.push(<ul key={`${msgId}-ul`}>{list}</ul>)
        list = null
      }
      if (line.trim() !== "") {
        elements.push(<div key={`${msgId}-p`}>{line}</div>)
      }
    }
  })
  if (list) elements.push(<ul key={`${msgId}-ul-last`}>{list}</ul>)
  return elements
}
